<template>
  <tooltip placement="top" :disabled="!linked" :options="{ hideOnClick: true }">
    <template #trigger>
      <span class="link" :class="{ disabled: linked }" @click="handleLinkCall">
        <i class="fa-solid fa-link-horizontal mr-1"></i>
      </span>
    </template>
    <template #tooltip> Already linked </template>
  </tooltip>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Tooltip from "@/components/Tooltip.vue";

export default {
  components: {
    Tooltip
  },
  props: {
    link: {
      type: String,
      default: null
    },
    callId: {
      type: Number,
      default: null
    },
    linked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions(["linkCall", "fetchJob"]),
    handleLinkCall() {
      if (this.link && !this.linked) {
        this.linkCall({ link: this.link, call_id: this.callId }).then(() => {
          window.notify.success("Phone call was successfully linked.");
          EventBus.$emit("refresh-datatable");
        });
      }
    }
  }
};
</script>
<style scoped>
.disabled {
  opacity: 0.6;
}
</style>
